import type { Website } from "@/constants/features";

const ROOT = "profiles";

export const lawyerProfileKeys = {
  all: [ROOT, "lawyer-profiles"] as const,
  list: (filters?: Record<string, unknown>) =>
    [ROOT, "lawyer-profiles", "list", filters ?? {}] as const,
  detail: (id: string) => [ROOT, "lawyer-profiles", "detail", id] as const,
};

export const firmProfileKeys = {
  all: [ROOT, "firm-profiles"] as const,
  list: (filters?: Record<string, unknown>) =>
    [ROOT, "firm-profiles", "list", filters ?? {}] as const,
  detail: (id: string) => [ROOT, "firm-profiles", "detail", id] as const,
};

export const firmTabKeys = {
  all: [ROOT, "firm-tabs"] as const,
  list: (filters?: Record<string, unknown>) => [ROOT, "firm-tabs", "list", filters ?? {}] as const,
  detail: (id: string) => [ROOT, "firm-tabs", "detail", id] as const,
};

export const articleKeys = {
  all: [ROOT, "articles"] as const,
  list: (filters?: Record<string, unknown>) => [ROOT, "articles", "list", filters ?? {}] as const,
  detail: (id: string) => [ROOT, "articles", "detail", id] as const,
};

export const teamPageKeys = {
  all: [ROOT, "team-pages"] as const,
  list: (filters?: Record<string, unknown>) => [ROOT, "team-pages", "list", filters ?? {}] as const,
  detail: (id: string) => [ROOT, "team-pages", "detail", id] as const,
};

export const officeAvailabilityKeys = {
  all: [ROOT, "office-availability"] as const,
  byCompany: (companyId: string) => [ROOT, "office-availability", companyId] as const,
};

export const firmLogoKeys = {
  all: [ROOT, "firm-logos"] as const,
  byCompany: (companyId: string) => [ROOT, "firm-logos", companyId] as const,
  profileWebsite: (companyId: string, website: Website) =>
    [ROOT, "firm-logo-profile-websites", companyId, website] as const,
};

export const auditKeys = {
  all: [ROOT, "audit"] as const,
  list: (filters?: Record<string, unknown>) => [ROOT, "audit", "list", filters ?? {}] as const,
  // `limit` is part of the key: two panels on the same entity with different
  // limits are different queries, so the cached page size must not be shared.
  forEntity: (entityType: string, entityId: string, limit?: number) =>
    [ROOT, "audit", "entity", entityType, entityId, limit ?? null] as const,
};
